export const locale = {
    id: 'en-UK',
    prefix: '',
    mailDomain: 'co.uk',
};
